import { PageContext, PageResource } from './types'

const entityRoutes: Record<string, PageResource> = {
    campaigns: 'campaign',
    journeys: 'journey',
    lists: 'list',
    users: 'user',
}

const listRoutes: Record<string, PageResource> = {
    campaigns: 'campaigns',
    journeys: 'journeys',
    lists: 'lists',
    users: 'users',
    events: 'events',
    settings: 'settings',
}

export const inferPageContext = (pathname: string): PageContext => {
    const projectPrefix = /^\/projects\/(\d+)(?:\/(.*))?$/
    const match = projectPrefix.exec(pathname)
    if (!match) return { pathname }
    const rest = (match[2] ?? '').replace(/\/$/, '')
    if (!rest) return { pathname, resource: 'project_home' }

    const parts = rest.split('/')
    const top = parts[0]
    // /projects/:p/<top>/:id(/<section>)?
    if (entityRoutes[top] && parts[1] && /^\d+$/.test(parts[1])) {
        return {
            pathname,
            resource: entityRoutes[top],
            id: parseInt(parts[1], 10),
            section: parts[2],
        }
    }
    if (listRoutes[top]) {
        return { pathname, resource: listRoutes[top] }
    }
    return { pathname }
}
